import { Route, Routes, Navigate } from 'react-router-dom';
import AppLayout from 'layouts/app-layout';
import AuthViews from 'views/auth-views';
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig';
import plPL from 'antd/locale/pl_PL';
import dayjs from 'dayjs';

import 'dayjs/locale/pl';

dayjs.locale('pl');

export const Views = () => {
  return (
    <ConfigProvider locale={plPL} direction="ltr">
      <Routes>
        <Route path={AUTH_PREFIX_PATH}>
          <Route
            path="*"
            element={
              <div className="auth-container">
                <AuthViews />
              </div>
            }
          />
        </Route>
        <Route path={APP_PREFIX_PATH}>
          <Route index path="*" element={<AppLayout />} />
        </Route>
        <Route path="*" element={<Navigate to={APP_PREFIX_PATH} replace />} />
      </Routes>
    </ConfigProvider>
  );
};

export default Views;
